import type { EntityCustomViewParams } from "@firecms/core";
import { Alert, Typography } from "@firecms/ui";

import { AppointmentTypesPanel } from "./modmed-resources/panels/AppointmentTypesPanel";
import { LocationsPanel } from "./modmed-resources/panels/LocationsPanel";
import { PractitionersPanel } from "./modmed-resources/panels/PractitionersPanel";

export const ModMedResourcesView = ({ entity, modifiedValues }: EntityCustomViewParams) => {
  const customerId = entity?.id;
  const isDirty = entity
    ? Boolean(modifiedValues) && JSON.stringify(modifiedValues) !== JSON.stringify(entity.values)
    : true;
  const disabled = !customerId || isDirty;

  return (
    <div className="flex flex-col gap-4 p-4">
      <div>
        <Typography variant="h6">ModMed Resources</Typography>
        <Typography variant="body2" color="secondary">
          Look up locations, appointment types, and practitioners for this practice. Each panel
          queries the ModMed API independently using the credentials saved on this document.
        </Typography>
      </div>
      {disabled && (
        <Alert color="warning">
          {customerId
            ? "Save your changes first — fetches use the credentials on disk."
            : "Save the document first. ModMed resources can only be fetched for an existing customer."}
        </Alert>
      )}
      <LocationsPanel customerId={customerId} disabled={disabled} />
      <AppointmentTypesPanel customerId={customerId} disabled={disabled} />
      <PractitionersPanel customerId={customerId} disabled={disabled} />
    </div>
  );
};
